module.exports = __webpack_public_path__ + "static/Walmart_pin-9f7773ce317e78a604ab8180dbcfb70b.png";